import React, { useRef, useState } from "react";
import styled from "styled-components";
import { Locale } from "@linkfluence/models/locale";
import Search from "@ui-kit/form/search";
import { tr } from "@radarly/i18n";
import Help from "./help";

export interface IProps {
  search: string;
  onSearch: (search: string) => void;
  onEnter?: () => void;
  locale: Locale;
  error?: boolean;
  visible?: boolean;
  restrictedOperators?: boolean;
  isReadOnly?: boolean;
  showCounter?: boolean;
  limitExceeded?: boolean;
  otherErrors?: string[];
}

const StyledSearch = styled(Search)<{ isReadOnly?: boolean }>`
  max-width: 712px;
  pointer-events: ${({ isReadOnly }) => (isReadOnly ? "none" : "auto")};
`;

const FilterbarPanelsSearch = ({
  search,
  error,
  onSearch,
  onEnter,
  locale,
  visible = true,
  restrictedOperators = false,
  isReadOnly = false,
  showCounter = false,
  limitExceeded = false,
  otherErrors,
}: IProps) => {
  const [firstMount, setFirstMount] = useState(visible);
  const [isFocused, setIsFocused] = useState(false);
  const childRef = useRef<{ onSelection: (selection: string) => void }>();

  React.useEffect(() => {
    setFirstMount(visible);
    setIsFocused(visible);
  }, [visible]);

  const addOperator = (operator: string, operatorSuffix: string = "") => {
    const selection = operator + operatorSuffix;
    if (childRef.current && !!selection) {
      childRef.current.onSelection(selection);
    }
  };

  return (
    <>
      <StyledSearch
        ref={childRef}
        value={search}
        size="l"
        placeholder={tr(locale, `SEARCH::PLACEHOLDER`)}
        locale={locale}
        syntaxError={error}
        firstMount={firstMount}
        visible={isFocused}
        onChange={onSearch}
        onEnter={onEnter}
        onClickOutside={() => setFirstMount(false)}
        isReadOnly={isReadOnly}
        showCounter={showCounter}
        limitExceeded={limitExceeded}
        otherErrors={otherErrors}
      />
      <Help
        locale={locale}
        onAddOperator={addOperator}
        restrictedOperators
        isDisabled={isReadOnly}
      />
    </>
  );
};

export default FilterbarPanelsSearch;
